<template>
  <v-dialog
      scrollable
      v-model="visible"
      max-width="900px"
      :fullscreen="fullscreen"
      :persistent="true"
  >
    <v-card>
      <v-toolbar flat dense>
        <v-toolbar-title class="subheading">查看</v-toolbar-title>

        <v-spacer/>

        <v-btn icon @click="fullscreen=!fullscreen">
          <v-icon>fullscreen</v-icon>
        </v-btn>
      </v-toolbar>

      <v-divider style="max-height: 1px"/>
      <v-progress-linear class="my-0" :indeterminate="true" :active="loading" height="2"/>

      <v-card-text>
        <v-container grid-list-md>
          <v-layout wrap>
            <v-flex xs12>
              <div class="x-text-field">
                <label>快捷用印业务名称</label>
                <div>{{item.name}}</div>
              </div>
            </v-flex>

            <v-flex xs12>
              <div class="body-2 mt-1" style="min-height: 20px;">
                <template v-if="item.seal && item.seal.description">
                  <strong>业务描述：</strong>{{ item.seal.description }}
                </template>
                <template v-else>
                  业务描述
                </template>
              </div>
            </v-flex>

            <v-flex xs12>
              <div class="body-2 mt-1" style="min-height: 20px;">
                <template v-if="item.proj && item.proj.name">
                  <strong>关联项目：</strong>{{ item.proj.name }}
                </template>
                <template v-else>
                  关联项目
                </template>
              </div>
            </v-flex>

            <v-flex xs12>
              <v-textarea
                  label="用印简要说明"
                  v-model="item.purpose"
              ></v-textarea>
            </v-flex>

            <v-flex xs3>
              <v-text-field
                  label="校章用印数"
                  readonly
                  outlined
                  v-model="item.instSealNum"
                  prepend-inner-icon="description"
                  color="primary"
              />
            </v-flex>

            <v-flex xs3>
              <v-text-field
                  label="法人章用印数"
                  v-model="item.corpSealNum"
                  readonly
                  outlined
                  prepend-inner-icon="description"
                  color="primary"
              />
            </v-flex>

            <v-flex xs3>
              <v-text-field
                  label="授权委托人章用印数"
                  readonly
                  outlined
                  v-model="item.prinSealNum"
                  prepend-inner-icon="description"
                  color="primary"
              />
            </v-flex>

            <v-flex xs3>
              <v-text-field
                  label="营业执照扫描件份数"
                  v-model="item.techSealNum"
                  readonly
                  outlined
                  prepend-inner-icon="description"
                  color="primary"
              />
            </v-flex>

            <v-flex xs4>
              <v-text-field
                  label="事业单位法人证书复印件数"
                  v-model="item.certiLegalNum"
                  hint="如不需要此类用印，请输入0！"
                  readonly
                  outlined
                  prepend-inner-icon="description"
                  color="primary"
              />
            </v-flex>

            <v-flex xs4>
              <v-text-field
                  label="授权委托人证书数"
                  v-model="item.certiAuthorNum"
                  hint="如不需要此类用印，请输入0！"
                  readonly
                  outlined
                  prepend-inner-icon="description"
                  color="primary"
              />
            </v-flex>

            <v-flex xs4>
              <v-text-field
                  label="科技院章用印数"
                  v-model="item.deptSealNum"
                  hint="如不需要此类用印，请输入0！"
                  readonly
                  outlined
                  prepend-inner-icon="description"
                  color="primary"
              />
            </v-flex>



            <!-- 附件 -->
            <v-flex
                xs12
                v-if="item.attachments && item.attachments.length > 0"
                class="enhanced-field"
            >
              <div class="enhanced-text-field">
                <label class="enhanced-label">附件列表</label>
                <div class="enhanced-attachment-list">
                  <div v-for="a in item.attachments" :key="a.dbid" class="enhanced-attachment-item">
                    <v-icon class="primary--text mr-2" small>insert_drive_file</v-icon>
                    <a :href="`/api/ctra/file/${a.dbid}`" target="_blank" class="enhanced-attachment-link">
                      {{a.fileName}} <span class="file-size">({{a.size | fileSize }})</span>
                    </a>
                  </div>
                </div>
              </div>
            </v-flex>

          </v-layout>
        </v-container>
      </v-card-text>

      <v-card-actions>
        <v-spacer/>
        <v-btn color="primary" @click.native="visible=false">关闭</v-btn>
      </v-card-actions>

    </v-card>
  </v-dialog>
</template>

<script>
import mixin from "@/mixin";
const baseUri = '/api/seal/quick';
export default {
  name: "View",
  mixins: [mixin.view(baseUri)],
  data() {
    return {
      fileUri: '/api/agmt/file',

      item: {},
    }
  },

}
</script>

<style scoped>

</style>